// src/pages/attendance/components/WeeklySection.jsx
import React from "react";
import { Calendar, BarChart3 } from "lucide-react";
import { Mo3tiCard, Mo3tiProgressBar } from "./mo3tiComponents";
import { getStatusIcon, getStatusColor, getStatusText, getStatusBadgeStyle, formatTimeForDisplay, calculateWorkingHours } from "../utils/attendanceHelpers";
import { getAttendanceStyles } from "../styles/attendanceStyles";

const WeeklySection = ({ weeklyData, t, currentTheme, isDarkMode, language }) => {
  const styles = getAttendanceStyles(currentTheme, isDarkMode, language);
  const c = currentTheme.colors;

  const totalHours = weeklyData.reduce((total, day) => {
    const h = calculateWorkingHours(day.checkIn, day.checkOut);
    return total + (h !== "--" ? parseFloat(h) : 0);
  }, 0);

  return (
    <>
      <Mo3tiCard title={t.weekly.title} icon={Calendar} theme={currentTheme}>
        <div style={styles.weeklyGrid}>
          {weeklyData.map((day, i) => {
            const StatusIcon = getStatusIcon(day.status);
            const statusColor = getStatusColor(day.status, c);
            const hours = calculateWorkingHours(day.checkIn, day.checkOut);

            return (
              <div key={i} style={styles.dayCard(day.status, c)}>
                <div style={styles.dayHeader}>
                  <StatusIcon size={32} color={statusColor} />
                  <div style={styles.dayName}>{day.day}</div>
                  <div style={{ ...getStatusBadgeStyle(day.status), fontFamily: "'Cairo', sans-serif", textTransform: "none" }}>
                    {getStatusText(day.status, t)}
                  </div>
                </div>

                <div style={styles.timeDetails}>
                  {day.status === "weekend" || day.checkIn === "-"
                    ? <div style={{ color: c.textMuted, fontStyle: "italic", fontFamily: "'Cairo', sans-serif" }}>{t.weekly.restDay}</div>
                    : <>
                        <div style={styles.timeRow}>
                          <span style={styles.timeLabel}>{t.weekly.in}</span>
                          <span style={styles.timeValue}>{formatTimeForDisplay(day.checkIn, language)}</span>
                        </div>
                        <div style={styles.timeRow}>
                          <span style={styles.timeLabel}>{t.weekly.out}</span>
                          <span style={styles.timeValue}>{formatTimeForDisplay(day.checkOut, language)}</span>
                        </div>
                        <div style={styles.hoursDisplay}>{hours} {t.units.hours}</div>
                      </>
                  }
                </div>
              </div>
            );
          })}
        </div>

        {/* summary */}
        <div style={styles.weeklySummary}>
          <h4 style={styles.summaryTitle}><BarChart3 size={20} color={c.primary} />{t.weekly.summary}</h4>
          <div style={styles.summaryGrid}>
            {[
              { value: weeklyData.filter((d) => d.status === "present").length, label: t.weekly.presentDaysCount, color: c.success },
              { value: weeklyData.filter((d) => d.status === "late").length,    label: t.weekly.lateArrivalsCount, color: c.warning },
              { value: weeklyData.filter((d) => d.status === "absent").length,  label: t.weekly.absentDaysCount,   color: c.danger },
              { value: `${totalHours.toFixed(1)} ${t.units.hours}`,             label: t.weekly.totalHoursCount,   color: c.primary },
            ].map((item, i) => (
              <div key={i} style={styles.summaryItem}>
                <div style={styles.summaryValue(item.color)}>{item.value}</div>
                <div style={styles.summaryLabel}>{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </Mo3tiCard>
    </>
  );
};

export default WeeklySection;